// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"ecabb751","787":"5b90298e"}[chunkId] + ".chunk.js";
};